import { Button, Col, Form, Popconfirm, Row, Tooltip, Typography } from "antd";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { successMsg, toConvertDate } from "../../../Utils/Utils";
import FactureModal from "./FactureModal";
import { toDeleteRetenu, toGetRetenus, toPrintRetenu } from "../APIs";

const RetenuList = () => {
  const [data, setData] = useState([]);
  const [factureToInspect, setFactureToInspect] = useState(null);
  const [selectedRetenu, setSelectedRetenu] = useState(null);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = () => {
    toGetRetenus().then((res) => {
      setData(res);
    });
  };
  const columns = [
    {
      name: "Client",
      selector: "clientName",
      sortable: true,
    },

    {
      name: "Crée par",
      selector: "createdBy",
      sortable: true,
      grow: 0.75,
    },
    {
      name: "Date",
      selector: "date",
      sortable: true,
      format: (row) => `${toConvertDate(row.date)}`,
    },
    {
      name: "Factures",
      selector: "id",
      sortable: true,
      format: (el) => (
        <>
          {el.factures.map((f) => (
            <>
              <Typography.Link
                level={5}
                style={{ cursor: "pointer" }}
                onClick={() => setFactureToInspect(f)}
              >
                {f.s__ref}
              </Typography.Link>
              <br />
            </>
          ))}
        </>
      ),
    },
    {
      name: "Total",
      selector: "total",
      sortable: true,
      format: (row) => `${row.total.toFixed(3) + " DT"}`,
    },
    {
      name: "Valeur",
      selector: "value",
      sortable: true,
      format: (row) => `${row.value.toFixed(3) + " DT"}`,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "1rem",
      },
    },
  };

  const onSelectRow = (e) => {
    setSelectedRetenu(e.selectedRows);
  };

  return (
    <>
      <Form layout="vertical">
        <Row className="auto--custom-header">
          <Col span="17">
            <Typography.Title level={5}>LISTE DES RETENUS</Typography.Title>
          </Col>

          <Col span="3" style={{ textAlign: "right" }}>
            <Tooltip title="Actualiser la liste des retenu">
              <Button
                onClick={() => fetchData()}
                type="link"
                size="large"
                style={{ marginRight: "15px" }}
                icon={<img src="/images/refresh.svg" />}
              ></Button>
            </Tooltip>
          </Col>
        </Row>
      </Form>
      <Row gutter="24" style={{ marginTop: "1vh" }}>
        <Col span="23">
          <DataTable
            customStyles={customStyles}
            columns={columns}
            data={data}
            pagination
            selectableRows
            noHeader
            striped
            selectableRowsHighlight
            fixedHeader
            onSelectedRowsChange={(e) => onSelectRow(e)}
            persistTableHead
            noDataComponent={<span>Pas de retenus trouvés</span>}
            contextMessage={{
              singular: "élément",
              plural: "éléments",
              message: "séléctionné(s)",
            }}
            paginationServer
            paginationTotalRows={data.length}
          />
        </Col>

        <Col span="1" className="auto--background-grey">
          {selectedRetenu?.length === 1 && (
            <>
              <Tooltip
                title="Pour supprimer le retenu"
                color="#58c5cc"
                placement="leftTop"
              >
                <Popconfirm
                  title={`Voulez vous vraiment supprimer le retenu?`}
                  onConfirm={() =>
                    toDeleteRetenu(selectedRetenu[0].id).then((res) => {
                      successMsg("Retenu supprimé avec succès");
                      fetchData();
                    })
                  }
                  okText="Oui"
                  cancelText="Non"
                  placement="left"
                >
                  <Button
                    type="link"
                    style={{ marginTop: "2vh" }}
                    icon={
                      <img
                        src="/images/trash.svg"
                        className="auto--icon-list"
                      ></img>
                    }
                  ></Button>
                </Popconfirm>
              </Tooltip>
              <Tooltip
                title="Pour imprimer le retenu"
                color="#58c5cc"
                placement="leftTop"
              >
                <Button
                  type="link"
                  onClick={(e) => toPrintRetenu(selectedRetenu[0].id)}
                  style={{ marginTop: "2vh" }}
                  icon={
                    <img
                      src="/images/print.svg"
                      className="auto--icon-list"
                    ></img>
                  }
                ></Button>
              </Tooltip>
            </>
          )}
        </Col>
      </Row>
      <FactureModal
        id={null != factureToInspect && factureToInspect.id}
        onClose={() => setFactureToInspect(null)}
      />
    </>
  );
};

export default RetenuList;
